import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { applicationPermissions } from 'src/app/shared/application-constants/application-permissions';
import { ExcelDownloadService } from 'src/app/shared/services/excel-download.service';
import { ActivatedRoute } from '@angular/router';
import { CertificateService } from 'src/app/shared/services/certificate.service';
import { StpApplicationDto } from 'src/app/modules/stp-registration/DTO/stp_application_dto.model';
import { STPOwnershipType } from 'src/app/modules/stp-registration/models/stp_ownership_type.model';
import { RequestData } from 'src/app/modules/stp-registration/models/stp_onlinePayment.model';
import { StpRegistrationStorageService } from 'src/app/modules/stp-registration/services/stp-registration-storage.service';
import { StpRegistrationService } from 'src/app/modules/stp-registration/services/stp-registration.service';
@Component({
  selector: 'app-stp-renew-reapply-archive-list',
  templateUrl: './stp-renew-reapply-archive-list.component.html',
  styleUrls: ['./stp-renew-reapply-archive-list.component.scss']
})
export class StpRenewReapplyArchiveListComponent implements OnInit {
applicationPermissions = applicationPermissions;
  stpApplicationDto: StpApplicationDto[] = [];
  searchingForm: FormGroup = this.fb.group({
    stpApplicationId: [null],
    stpName: [null],
    stpOwnerShipStatusId: [null],
    sysDistrictId: [null],
    occupationName: [null],
    registrationNo: [null],
  });
  deleteAfterDays: any;
  reportData = [];
  reportTitle = 'STP Application List';
  stpOwnershipTypeList: STPOwnershipType[] = [];
  districtList: any[];

  requestData: RequestData = new RequestData();
  userInfo: any;
  
  // for pagination
  total: number;
  size: number = 10;
  page: number = 1;
  sortingKey: string = 'id';
  sortingValue: string = 'descend';
  
  rollbackButtonDisabled: boolean = false;

  contentVisble = false;

  constructor(
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private stpRegistrationService: StpRegistrationService,
    private fb: FormBuilder,
    private notification: NzNotificationService,
    private excelExport: ExcelDownloadService,
    private route: ActivatedRoute,
    private certificateService: CertificateService,
  ) {
    this.userId();
  }

  ngOnInit(): void {
    this.getOwnerShipTypeList();
    this.getStpDistrictsList();
    this.getSetupInfo();
    this.loadArchiveStpApplicationsFromServer();
  }

  userId() {
    this.userInfo = JSON.parse(localStorage.getItem('currentUserInfo') || '{}');
    this.requestData.id = this.userInfo.id;
    if (this.userInfo.id) this.contentVisble = true;
  }

  loadArchiveStpApplicationsFromServer(): void {
    this.rollbackButtonDisabled = false;

    this.stpRegistrationStorageService
      .readArchiveStpApplicationsList(
        this.page,
        this.size,
        this.searchingForm.value,
        this.sortingKey,
        this.sortingValue,
      )
      .subscribe({
        next: (res) => {
          if (res.success && res.data) {
            this.stpApplicationDto = res.data.content;
            this.total = res.data.totalElements;
          } else {
            this.stpApplicationDto = [];
            this.total = 0;
          }
        },
        error: () => {
          this.stpApplicationDto = [];
          this.total = 0;
        },
      });
  }

  onRollBack(stpApplicationDto: StpApplicationDto) {
    const stpUserId = stpApplicationDto.stpUserId;
    this.stpRegistrationStorageService
      .initiateRollBackRequest(stpUserId)
      .subscribe(
        (res) => {
          this.notification.success('Success!', res.message);
          this.rollbackButtonDisabled = true;
          stpApplicationDto.applicationStatus = 'On Going';
        },
        (error) => {
          this.notification.error('Error!', error.message);
          this.rollbackButtonDisabled = false;
        },
      );
  }

  onSearch() {
    this.page = 1;
    this.size = 10;
    this.loadArchiveStpApplicationsFromServer();
  }

  onRefresh() {
      this.searchingForm.reset();
      this.onSearch();
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.page = params.pageIndex;
    this.size = params.pageSize;
    params.sort.forEach((element) => {
      if (element.value != null) {
        this.sortingKey = element.key;
        this.sortingValue = element.value;
      }
    });
    this.loadArchiveStpApplicationsFromServer();
  }

  getOwnerShipTypeList() {
    this.stpRegistrationStorageService.readStpOwnerShipType().subscribe({
      next: (res) => {
        this.stpOwnershipTypeList = res;
      },
    });
  }

  getStpDistrictsList() {
    this.stpRegistrationStorageService.readStpDistricts().subscribe({
      next: (res) => {
        this.districtList = res;
      },
    });
  }

  getSetupInfo() {
    this.stpRegistrationStorageService.getSetupInfo().subscribe((res) => {
      if (res?.success) {
        this.deleteAfterDays = res?.data?.deleteAfterDays;
      }
    });
  }

  cancel(): void {
    // this.msg.info('click cancel');
  }
}